<ng-container *ngIf="vm$ | async as vm">
	<div class="flex flex-col h-full">
		<ui-content-header
			[title]="vm.title"
			class="p-6 border-b border-red-200 bg-red-50"
			icon="alert-triangle"
		>
			<ui-button
				actions
				icon="x"
				(click)="closeModal()"
				preset="ICON_DEFAULT"
			></ui-button>
		</ui-content-header>

		<div class="flex flex-col gap-6 flex-grow p-8">
			<div>
				<p *ngIf="vm.disclaimer" class="mt-2 mb-4">{{ vm.disclaimer }}</p>
				{{ vm.content }}
			</div>

			<app-dropdown
				*ngIf="vm.showDropdown"
				class="w-full"
				[itemGroups]="[{ items: usersSelectionItems }]"
				[ngModel]="vm.selectedUser?.name"
				(onSelect)="userSelected($event)"
				placeholder="Do Not Reassign"
			>
			</app-dropdown>
		</div>

		<ui-content-footer
			[leftAction]="vm.leftAction"
			[secondaryAction]="vm.secondaryAction"
			[primaryAction]="vm.primaryAction"
		>
		</ui-content-footer>
	</div>
</ng-container>
